import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { Shield, Smartphone, Save, Building } from 'lucide-react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import api from '../../api/axios';
import styles from './Settings.module.css';

const Settings = () => {
  const [passwordForm, setPasswordForm] = useState({ current: '', newPass: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if(passwordForm.newPass !== passwordForm.confirm) {
      toast.error("New Passwords do not match!");
      return;
    }
    
    if (passwordForm.newPass.length < 6) {
      toast.error("Password must be at least 6 characters long.");
      return;
    }

    try {
      setLoading(true);
      await api.put('/users/profile', {
        currentPassword: passwordForm.current,
        password: passwordForm.newPass
      });
      toast.success("Admin Password updated successfully!");
      setPasswordForm({ current: '', newPass: '', confirm: '' });
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <PageHeader 
        title="Admin Settings" 
        breadcrumb={['Account', 'Settings']} 
      />

      <div className={styles.contentGrid}>
        <div className={styles.column}>
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <Shield size={20} className={styles.icon} />
              <h2>Security Settings</h2>
            </div>
            <div className={styles.cardBody}>
              <form onSubmit={handlePasswordSubmit} className={styles.passwordForm}>
                <div className={styles.inputGroup}>
                  <label>Current Password</label>
                  <input type="password" value={passwordForm.current} onChange={e => setPasswordForm({...passwordForm, current: e.target.value})} required />
                </div>
                <div className={styles.inputGroup}>
                  <label>New Password</label>
                  <input type="password" value={passwordForm.newPass} onChange={e => setPasswordForm({...passwordForm, newPass: e.target.value})} required />
                </div>
                <div className={styles.inputGroup}>
                  <label>Confirm New Password</label>
                  <input type="password" value={passwordForm.confirm} onChange={e => setPasswordForm({...passwordForm, confirm: e.target.value})} required />
                </div>
                <button type="submit" className={styles.saveBtn} disabled={loading}>
                  <Save size={16} /> {loading ? 'Updating...' : 'Update Password'}
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className={styles.column}>
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <Building size={20} className={styles.icon} />
              <h2>Society Profile</h2>
            </div>
            <div className={styles.cardBody}>
              <div className={styles.inputGroup}>
                <label>Society Name</label>
                <input type="text" value="Sanskriti Shubh Aangan" disabled />
              </div>
              <div className={styles.inputGroup}>
                <label>Registration Number</label>
                <input type="text" value="MP-09-REG-SANSKRITI" disabled />
              </div>
              <small className={styles.helperText}>Contact Super Admin to change society details.</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
